import { Koi } from '@ksyos/koi';

export interface IPatientDeliveryInfo {
    city?: string | null;
    houseNumber?: string | null;
    houseNumberSuffix?: string | null;
    street?: string | null;
    zip?: string | null;
}

export const patientDeliveryInfoFinal = Koi.object().keys({
    city: Koi.string().max(255).required(),
    houseNumber: Koi.string().max(255),
    houseNumberSuffix: Koi.string().max(255).allow(null, '').optional(),
    street: Koi.string().max(255),
    zip: Koi.string().zipCodeNL().required(),
});

export const patientDeliveryInfoDraft = Koi.object().keys({
    city: Koi.string().max(255).allow(null).optional(),
    houseNumber: Koi.string().max(255).allow(null, '').optional(),
    houseNumberSuffix: Koi.string().max(255).allow(null, '').optional(),
    street: Koi.string().max(255).allow(null).optional(),
    zip: Koi.string().allow(null).optional(),
});
